import { environment } from '../../environments/environment';
import { AddressBookComponent } from './address-book.component';
import { roleGuard } from '../shared/core/role-guard.service';
import { CompanyItemComponent } from './company-item.component';
import { pendingChangesGuard } from '../shared/core';

export const routes = [
    {
        path: 'addressbook', component: AddressBookComponent,
        canActivate: [roleGuard],
        data: { roles: [environment.clearanceRole, environment.productionRole] }
    },
    {
        path: 'addressbook/:companyId', 
        component: CompanyItemComponent,
        canActivate: [roleGuard],
        canDeactivate: [pendingChangesGuard],
        data: { roles: [environment.clearanceRole, environment.productionRole] }
    },
];
